import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
var that;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  today = new Date();
  // jstoday = '';
  currentTime = '';
  currentDate = '';
  timeId!: NodeJS.Timeout;

  constructor() {

  }

  ngOnInit(): void {
    that = this;
    // this.jstoday = formatDate(this.today, 'hh:mm a | E | dd/MM/yy', 'en-US', '+0530');
    that.startTime();
  }

  startTime() {
    let today = new Date();
    let hr = today.getHours();
    let min = today.getMinutes();
    let sec = today.getSeconds();
    let ap = '';
    ap = (hr < 12) ? "AM" : "PM";
    hr = (hr == 0) ? 12 : hr;
    hr = (hr > 12) ? hr - 12 : hr;
    //Add a zero in front of numbers<10
    hr = this.checkTime(hr);
    min = this.checkTime(min);
    sec = this.checkTime(sec);
    this.currentTime = hr + ":" + min + ":" + sec + " " + ap;

    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var curWeekDay = days[today.getDay()];
    var curDay = today.getDate();
    var curMonth = months[today.getMonth()];
    var curYear = today.getFullYear();
    var date = curWeekDay + ", " + curDay + " " + curMonth + " " + curYear;
    this.currentDate = date;

    // this.timeId = setTimeout(function () { that.startTime() }, 500);
    this.timeId = setTimeout(() => {
      this.startTime();
    }, 500);
  }
  checkTime(i:any) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  ngOnDestroy() {
    clearTimeout(this.timeId);
  }

}
